// @module Bolle.HideDealerPrices.HideDealerPricesButton
define('Code25.CaterpartsGlobal.Related.View'
  , [
    'c25_related.tpl'
    , 'Backbone'
    , 'ItemRelations.Related.Collection'
    , 'ItemRelations.Correlated.Collection'
    , 'RecentlyViewedItems.Collection'
    , 'Tracker'
    , 'Facets.Helper'
    , 'FacetsItemsCollectionView'
    , 'Utils'
    , 'Tools'
    , 'Code25.CaterpartsGlobal.CatCollection'
    , 'Code25.ReorderItems.Model'
    , 'Profile.Model'
  ]
  , function (
    c25_related_tpl
    , Backbone
    , ItemRelationsRelatedCollection
    , ItemRelationsCorrelatedCollection
    , RecentlyViewedItemsCollection
    , Tracker
    , FacetsHelper
    , FacetsItemsCollectionView
    , Utils
    , Tools
    , Code25CaterpartsGlobalCatCollection
    , ReorderItemsModel
    , ProfileModel
  ) {
    'use strict';

    var relatedmodel, relatedItemIds, relatedView, relatedVanStock, relatedVanStockDate = new Date(0);
    return Backbone.View.extend({

      template: c25_related_tpl,
      initialize: function () {

        this.translatorConfig = this.options.application.translatorConfig;

        var fullurl = Backbone.history.fragment;

        this.translator = FacetsHelper.parseUrl(
          fullurl,
          this.translatorConfig,
          false
        );

        var itemsDisplayOptions = this.options.application.getConfig().itemsDisplayOptions;
        this.itemsDisplayOptions = Utils.deepCopy(itemsDisplayOptions);

        this.offset = Math.floor(Math.random() * 12) * 24;

        if (this.options.related || this.options.tile) {
          this.collection = new ItemRelationsRelatedCollection({ itemsIds: this.options.itemsIds });

        } else if (this.options.category) {

          if (this.options.categoryUrl == "/reorder") {

            this.collection = { length: 0 };
            var isLoggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
            if (isLoggedIn) {
              relatedView = this;
              if (Array.isArray(relatedItemIds)) {
                if (relatedItemIds.length > 0) {
                  this.collection = new ItemRelationsCorrelatedCollection({ itemsIds: relatedItemIds });
                  // console.log("found items! ",relatedItemIds)
                }
              } else if (!relatedmodel) {
                relatedItemIds = [];
                relatedmodel = new ReorderItemsModel();
                relatedmodel.fetch(
                  { data: {} }
                ).done(function (result) {
                  var records = relatedmodel.get("records");
                  for (var i = 0; i < records.length; i++) {
                    relatedItemIds.push(records[i].item.internalid);
                  }
                  relatedView.initialize();
                  relatedView.render();

                }).catch(function (err) {
                  console.log(err);
                });
              }
            }

          } else {
            this.collection = new Code25CaterpartsGlobalCatCollection({ categoryUrl: this.options.categoryUrl });
          }
        } else if (this.options.correlated) {
          this.collection = new ItemRelationsCorrelatedCollection({ itemsIds: this.options.itemsIds });
        } else if (this.options.recent) {
          this.collection = RecentlyViewedItemsCollection.getInstance();
        }


        if (this.options.recent) {

          this.once('afterCompositeViewRender', this.loadRecentlyViewedItem, this);
        } else {
          this.once('afterCompositeViewRender', this.loadRelatedItem, this);
        }
      },
      loadRecentlyViewedItem: function loadRecentlyViewedItem() {
        var self = this;

        RecentlyViewedItemsCollection.getInstance().turnOnTracking();

        self.collection && self.collection.promise &&
          self.collection.promise.done(function () {
            if (self.options.category) {
              self.collection = self.collection.first(12);
            } else {
              self.collection = self.collection.first(6);
            }

            self.render();
            Tools.adjustSpacers();
          });
      },

      loadRelatedItem: function loadRelatedItem() {
        var self = this;

        self.collection.fetchItems && self.collection.fetchItems().done(function () {

          if (self.collection.length) {

            if (self.collection.length > 4) {
              var index, swap;
              for (var i = 0; i < self.collection.models.length; i++) {
                index = Math.floor(Math.random() * self.collection.models.length);
                if (index != i) {
                  swap = self.collection.models[i];
                  self.collection.models[i] = self.collection.models[index];
                  self.collection.models[index] = swap;
                }
              }
            }

            while (self.collection.length > 12) {
              self.collection.models.pop();
              self.collection.length--;
            }


            if (!self.view_tracked) {
              Tracker.getInstance().trackProductListEvent(self.collection, 'Related Items');
              self.view_tracked = true;
            }

            self.render();
            Tools.adjustSpacers();

          } else if (self.options.confirmation && !self.empty) {
            self.empty = true;
            var time = new Date().getTime() - relatedVanStockDate.getTime();
            relatedVanStockDate = new Date();
            if (time / 1000 > 5) {
              relatedVanStock = new Code25CaterpartsGlobalCatCollection({ categoryUrl: "/van-stock", limit: 24, offset: self.offset });
            }
            self.collection = relatedVanStock;

            self.loadRelatedItem();
          }



        });
      },

      destroy: function destroy() {
        this._destroy();

        if (this.options.recent) {

          this.off('afterCompositeViewRender', this.loadRecentlyViewedItem, this);
        } else {
          this.off('afterCompositeViewRender', this.loadRelatedItem, this);
        }
      },
      relatedViewMore: function (e) {

        var $related = jQuery(e.target).closest(".item-relations-correlated-row");
        $related.addClass("related-force-open");

      },
      scrollPrev: function (e) {
        var $box=this.$el.find(".facets-facet-browse-items");
        $box[0].scrollBy({top:0,left:$(document).width()/-2,behavior:"smooth"});
      },
      scrollNext: function (e) {
        var $box=this.$el.find(".facets-facet-browse-items");
        $box[0].scrollBy({top:0,left:$(document).width()/2,behavior:"smooth"});
      },
      events: {
        'click [data-action="related-view-more"]': 'relatedViewMore',
        'click [data-action="scroll-prev"]': 'scrollPrev',
        'click [data-action="scroll-next"]': 'scrollNext'
      },
      childViews: {
        'Facets.Items': function () {
          var self = this;
          var display_option = _.find(this.itemsDisplayOptions, function (option) {
            return option.id === self.translator.getOptionValue('display');
          });
          if (FacetsItemsCollectionView.FacetsItemsCollectionView) {
            FacetsItemsCollectionView = FacetsItemsCollectionView.FacetsItemsCollectionView;
          }
          var viewsPerRow = parseInt(display_option.columns, 10);

          if (self.options.category) {
            viewsPerRow = 4;
          } else {

            if (viewsPerRow >= 2) {
              viewsPerRow += 2;
            } else {
              viewsPerRow += 1;
            }
          }

          return new FacetsItemsCollectionView({
            application: this.options.application,
            collection: this.collection.models || this.collection,
            viewsPerRow: viewsPerRow,
            cellViewTemplate: display_option.template
          });
        }
      }

      , getContext: function () {
        return {
          showButtons:this.collection.length > 1,
          showCells: this.collection.length > 0,
          related: this.options.related,
          recent: this.options.recent,
          correlated: this.options.correlated,
          tile: this.options.tile,
          featuredIndex: this.options.featuredIndex,
          confirmation: this.options.confirmation
        };
      }
    });
  });
